// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__X_QPr","signatureBlock":"Footer_signatureBlock__2RU7n","signature":"Footer_signature__1RcUV"};